import { render, staticRenderFns } from "./Swear.vue?vue&type=template&id=35a9800c&scoped=true&"
import script from "./Swear.vue?vue&type=script&lang=js&"
export * from "./Swear.vue?vue&type=script&lang=js&"
import style0 from "./Swear.vue?vue&type=style&index=0&id=35a9800c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9800c",
  null
  
)

export default component.exports